import React, { useState } from 'react'
import { MenuOpcoesInterface } from '../Layout/MenuCls'


export interface LayoutStateInterface {
  exibirMenu: boolean
  opcoesMenu: Array<MenuOpcoesInterface>
}

export default function useLayoutState () {

  const [layoutState, setLayoutState] =
    useState<LayoutStateInterface>( {
      exibirMenu: false,
      opcoesMenu: []
    } )

  return { layoutState, setLayoutState }

}